<template>
    <div v-if="itemValue !== undefined">
        <template v-if="settings.type === 'bool'">
            <font-awesome-icon v-if="itemValue === true" icon="check-circle" class="text-success" />
            <span v-if="itemValue === true">Yes</span>
            <font-awesome-icon v-if="itemValue === false" icon="times-circle" class="text-danger" />
            <span v-if="itemValue === false">No</span>
        </template>
        <img v-else-if="settings.type === 'lang'  && itemValue !== null"
             :src="'/static/flags/4x3/'+ itemValue + '.svg'"
             class="flag-icon"
        >
        <template v-else-if="settings.type === 'date' && itemValue !== null">
            {{ itemValue | formatDate }}
        </template>
        <template v-else-if="settings.type === 'dateTime' && itemValue !== null">
            {{ itemValue | formatDateTime }}
        </template>
        <template v-else-if="settings.type === 'user' && itemValue !== null">
            {{ itemValue.fullName }}
        </template>
      <template v-else-if="settings.type === 'multiselect' && itemValue !== null">
        <TitanCheckbox :checked="isSelected()" @toggle="$emit('toggleSelected', itemValue)"/>
      </template>
        <template v-else-if="itemValue !== null">
            {{ itemValue }}
        </template>
    </div>
</template>
<script>
    import moment from 'moment'
    import TitanCheckbox from '../TitanCheckbox'
    import { get } from 'lodash'

    export default {
        components: {
            TitanCheckbox
        },
        props: {
            item: {
                type: Object,
                required: true
            },
            settings: {
                type: Object,
                required: true
            },
            selected: {
                type: Array,
                required: true
            }
        },
        filters: {
            formatDate: function (date) {
                return moment(date).format('DD.MM.YYYY');
            },
            formatDateTime: function (date) {
                return moment(date).format('DD.MM.YYYY HH:mm:ss');
            }
        },
        computed: {
            itemValue() {
                return get(this.item, this.settings.key);
            }
        },
        methods: {
            isSelected() {
                return this.selected.includes(this.itemValue);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/core/DataGrid/Column.vue